import './ServiceRequestAuthorizedUser.css';

import InputWidget from '../../../lib/InputWidget/InputWidget';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  pushViewAction,
  getAuthorizedUserDetailsAction,
  getServiceRequestDetailsAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {getAPICall} from '../../../services/apiCallsHandler';
import 'flatpickr/dist/themes/light.css';
import {emailRegex} from '../../../utils/constant';
import Smartlook from '../../../utils/smartlook';
import {
  replaceTranslations,
  sanitizeInput,
  sendScreenViewNR,
  serviceRequestPostCall,
} from '../../../utils/util';
import CurrentlyUnavailableCard from '../../currently_unavailable_div/CurrentlyUnavailableCard';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {
  Card,
  Box,
  CardContent,
  Button,
  CircularProgress,
  useToastProvider,
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
  TextField,
} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ServiceRequestAuthorizedUser = (props) => {
  const {t} = useTranslation();
  const {enqueueToast} = useToastProvider();
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [displayUnavailableCard, setDisplayUnavailableCard] =
    React.useState(false);
  const [manageUserType, setManageUserType] = React.useState(
    'Add Authorized User'
  );
  const [userNameOptions, setUserNameOptions] = React.useState([]);
  const [userName, setUserName] = React.useState();
  const [addInfoComment, setAddInfoComment] = React.useState('');

  const [name, setName] = React.useState('');
  const [designation, setDesignation] = React.useState('Director');
  const [email, setEmail] = React.useState('');
  const [reason, setReason] = React.useState('');
  const reasonTypesForAllCountries = [
    {
      label: 'DIRECTOR',
      value: 'Director',
    },
    {
      label: 'PARTNER',
      value: 'Partner',
    },
  ];
  React.useEffect(() => {
    setIsLoading(true);
    sendScreenViewNR('AuthrizedUserRequest');
    Smartlook.navigation('AuthrizedUserRequest');
    getAPICall(
      `myAccount`,
      {
        isCallBack: false,
        errorTag: 'GET_MYACCOUNT_DETAIL',
        redirectToOops: false,
      },
      {
        stateName: 'authorizedUserDetails',
        actionName: getAuthorizedUserDetailsAction,
      }
    ).then((res) => {
      if (res.isError) {
        setIsLoading(false);
        setDisplayUnavailableCard(true);
      } else {
        setIsLoading(false);
      }
    });
  }, []);

  React.useEffect(() => {
    if (props.authorizedUserDetails) {
      setUserNameOptions(
        props.authorizedUserDetails
          ?.filter(
            (item) => item.name !== props.userName && item.isDelegate === false
          )
          ?.map((user) => ({
            label: user.name,
            value: user.name,
          }))
      );
    }
  }, [props.authorizedUserDetails]);

  React.useEffect(() => {
    if (
      name &&
      name.length > 0 &&
      designation.length > 0 &&
      emailRegex.test(email)
    ) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [name, designation, email, reason]);

  React.useEffect(() => {
    if (userName && userName.length > 0 && addInfoComment.length > 0) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [userName, addInfoComment]);

  const handleName = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setName(sanitizedInput);
  };

  const handleDesignation = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setDesignation(sanitizedInput);
  };

  const handleEmail = (value) => {
    setEmail(value.trim());
  };

  const handleReason = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setReason(sanitizedInput);
  };

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          type="submit"
          disabled={submitDisabled}
          id="AuthorizedUserPrimaryBtn"
          variant="primary"
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };

  const authorizedUserSubmitHandler = (e) => {
    const reqBody = {};
    reqBody.manageUserType = manageUserType;
    reqBody.contractNumber = props.contractNumber;
    reqBody.countryCode = props.country;
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    if (manageUserType == 'Add Authorized User') {
      reqBody.name = name;
      reqBody.designation = designation;
      reqBody.email = email;
      reqBody.reason = reason;
    }

    if (manageUserType == 'Remove Authorized User') {
      reqBody.userName = userName;
      reqBody.addInfoComment = addInfoComment;
    }

    e.preventDefault();
    setSubmitDisabled(true);
    setLoader(true);
    serviceRequestPostCall(
      {
        requestType: 'Modification in Authorised Signatory',
        countryCode: props.country,
        userEmail: props.userDetails.email,
        ...reqBody,
      },
      enqueueToast,
      'AUTHORIZED_USER_MANAGE_SERVICE_REQUEST',
      () => {
        setLoader(false);
        setSubmitDisabled(false);
      },
      replaceTranslations(
        t('SERVICE_REQUEST_LIMIT'),
        50,
        t('AUTHORIZED_USER_MANAGE')
      ),
      t('SERVICE_REQUEST_SUCCESS'),
      t('SERVICE_REQUEST_CREATION_FAILED'),
      () => {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    );
  };

  let helperTextSignatoryEmail = null;
  if (email?.trim()?.length <= 0) {
    helperTextSignatoryEmail = 'FAQ_MODAL_ERROR';
  } else if (!emailRegex.test(email)) {
    helperTextSignatoryEmail = 'FAQ_MODAL_EMAIL_ERROR';
  }
  const formFields = [
    {
      label: 'SIGNATORY_NAME',
      type: 'text',
      required: true,
      id: 'authorized-user-name',
      value: name,
      setValue: handleName,
      error: name.length > 0,
      helperText: 'FAQ_MODAL_ERROR',
    },
    {
      label: 'SIGNATORY_DESIGNATION',
      type: 'dropDown',
      required: true,
      id: 'authorized-user-designation',
      value: designation,
      setValue: handleDesignation,
      error: designation.length > 0,
      helperText: 'REASON_HELPER_TEXT',
    },
    {
      label: 'SIGNATORY_EMAIL',
      type: 'text',
      required: true,
      id: 'authorized-user-email',
      value: email,
      setValue: handleEmail,
      error: emailRegex.test(email),
      helperText: helperTextSignatoryEmail,
    },
    {
      label: 'SIGNATORY_REASON',
      type: 'text',
      required: false,
      id: 'authorized-user-reason',
      value: reason,
      setValue: handleReason,
      error: true,
      helperText: 'ZIPCODE_MANDATORY',
      multiline: true,
      minRows: 2,
    },
  ];

  const renderCurrentlyUnavailableCard = () => {
    return (
      <CurrentlyUnavailableCard
        title={t('SOMETHING_WENT_WRONG')}
        subTitle={t('SERV_DASHBOARD_NOT_AVAILABLE')}
        fullScreen={true}
      />
    );
  };

  return (
    <div>
      <Box>
        <div>
          {isLoading ? (
            <SkeletonLoader componentName="ServiceRequestDashboard" />
          ) : displayUnavailableCard ? (
            renderCurrentlyUnavailableCard()
          ) : (
            <div className={'ServiceRequestChangePhoneWrapper'}>
              <div className={'ServiceRequestCard'}>
                <div className="serviceRequestHeader">
                  <div className={'title'}>{t('AUTHORIZED_USER_REQUEST')}</div>
                </div>
                <div className={'subTitle'}>
                  {t('AUTHORIZED_USER_REQUEST_SUBTITLE')}
                </div>
              </div>
              <Box pl={4} pr={4} pb={4}>
                <form onSubmit={authorizedUserSubmitHandler}>
                  <Typography gutterBottom variant="h5" required={true}>
                    {t('AUTHORIZED_USER_CHOOSE_OPTION')}
                    <span className="datepicker-asterisk">*</span>
                  </Typography>
                  <RadioGroup
                    name="group1"
                    data-testid="radio-button-id"
                    className="AuthorizedUserType"
                    defaultValue={manageUserType}
                    onClick={(e) => setManageUserType(e.target.value)}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label={t('AUTHORIZED_USER_ADD')}
                      value="Add Authorized User"
                    />
                    {props.authorizedUserDetails &&
                    props.authorizedUserDetails.length > 0 &&
                    userNameOptions.length > 0 ? (
                      <FormControlLabel
                        control={<Radio />}
                        label={t('AUTHORIZED_USER_REMOVE')}
                        value="Remove Authorized User"
                      />
                    ) : null}
                  </RadioGroup>

                  {manageUserType !== 'Add Authorized User' && (
                    <Card className="AuthorizedUserCardCustom RemoveCardContainer">
                      <CardContent className="AuthorizedUserCard">
                        <div className="AuthorizedUserAddressSection">
                          <div className={'ServiceRequestCard'}>
                            <div className="serviceRequestHeader">
                              <div className={'title'}>
                                {t('REMOVE_EXISTING_USER_TITLE')}
                              </div>
                            </div>
                            <div className={'subTitle'}>
                              {t('REMOVE_EXISTING_USER_SUB_TITLE')}
                            </div>
                          </div>
                          <div className="AuthorizedUserContainer">
                            <div className="AuthorizedUserReasonWrapper">
                              <SelectWidget
                                id="AuthorizedUser-reason"
                                label={t('AUTHORIZED_USER_NAME')}
                                changeHandler={setUserName}
                                data={userNameOptions}
                                defaultValue={userName}
                                value={userName}
                                required={true}
                                className={'reasonType'}
                                helperText={t(
                                  'AUTHORIZED_USER_NAME_HELPERTEXT'
                                )}
                              />
                            </div>
                            <div className="AuthorizedUserReasonWrapperSecond">
                              <TextField
                                className="ChangePhoneTextField"
                                label={t('ADD_INFO_FOR_REQUEST')}
                                type="number"
                                data-testid="change-phone-number"
                                required={false}
                                value={addInfoComment}
                                multiline
                                minRows={2}
                                size="small"
                                onChange={(e) =>
                                  setAddInfoComment(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  )}

                  {manageUserType !== 'Remove Authorized User' && (
                    <Card className="AuthorizedUserCardCustom AddUserCardContainer">
                      <CardContent className="AuthorizedUserCard">
                        <div className="AuthorizedUserAddressSection">
                          <div className={'ServiceRequestCard'}>
                            <div className="serviceRequestHeader">
                              <div className={'title'}>{t('ADD_NEW_USER')}</div>
                            </div>
                            <div className={'subTitle'}>
                              {t('ADD_NEW_USER_SUBTITLE')}
                            </div>
                          </div>
                          <div className="AuthorizedUserContainer ChangeAddressCard">
                            {formFields.map((i, index) =>
                              i.type === 'text' ? (
                                <InputWidget
                                  key={i.id}
                                  required={i.required}
                                  type={i.type}
                                  id={i.id}
                                  label={t(i.label)}
                                  value={i.value}
                                  setValue={i.setValue}
                                  customError={true}
                                  error={i.error}
                                  helperText={t(i.helperText)}
                                  multiline={i.multiline}
                                  minRows={i.minRows}
                                />
                              ) : (
                                <div key={i.id}>
                                  <SelectWidget
                                    id={i.id}
                                    label={t(i.label)}
                                    changeHandler={i.setValue}
                                    /*setValue={i.setValue}*/
                                    data={reasonTypesForAllCountries}
                                    required={i.required}
                                    defaultValue={designation}
                                    helperText={t(i.helperText)}
                                    className={'reasonType'}
                                  />
                                </div>
                              )
                            )}
                          </div>
                          <Typography className="add-user-note">
                            {t('AUTHORIZED_USER_ADD_NOTE')}
                          </Typography>
                        </div>
                      </CardContent>
                    </Card>
                  )}

                  {formButtonControls()}
                </form>
              </Box>
            </div>
          )}
        </div>
      </Box>
    </div>
  );
};

ServiceRequestAuthorizedUser.propTypes = {
  cancelButtonClick: PropTypes.func,
  contractNumber: PropTypes.string,
  selectedParty: PropTypes.string,
  authorizedUserDetails: PropTypes.array,
  country: PropTypes.string,
  userName: PropTypes.string,
};

export const mapStateToProps = (state) => {
  return {
    authorizedUserDetails: state.appStates.authorizedUserDetails,
    userDetails: state.appStates.userDetailsInfo,
    country: state.appStates.allContracts?.countryCode,
    userName: state.appStates.allContracts?.userName,
  };
};

export default connect(mapStateToProps)(ServiceRequestAuthorizedUser);
